<figure class="performance-hero-photo">
  <img
    ngSrc="/images/r11-768x1151.webp"
    width="768"
    height="1151"
    alt="Russ on bass at a venue performance"
    sizes="(max-width: 48rem) 100vw, 18rem"
    priority
  />
  <figcaption>Russ on bass — live performance.</figcaption>
</figure>

<p class="performance-lede">
  Forty-plus years of professional bass playing that covers touring, recording,
  jam sessions, and pickup work across jazz, blues, R&amp;B, soul, swing, Latin,
  and fusion. Currently based in
  <strong>Boynton Beach, Florida</strong>
  and performing across the state.
</p>

<h2>What Russ Brings</h2>
<p>
  Versatile bass voice that fits the room, from quartet jazz dates to blues and
  Latin sessions to swing. Equally comfortable in small-combo recording sessions
  and clinic / educational settings. Russ has performed and recorded with a wide
  range of national and local artists; see the full list on the
  <a [routerLink]="'/about/credits'">credits</a>
  page.
</p>

<h2>Where Russ Has Played</h2>
<p>
  Russ built his career in Atlanta. He founded the Bass Program at the Atlanta
  Institute of Music in 1985 and spent close to three decades on the city's jazz
  and session scene, including eight years as the house bassist for the Ritz
  Carlton Jazz Trio and studio work on national radio and television spots. In
  2014 he moved to the Washington DC area and freelanced across DC, Maryland,
  and Northern Virginia for twelve years. In 2026 he relocated to South Florida,
  where he now performs across the region.
</p>

<h2>Recording Credits</h2>
<p>
  Studio recordings on the discography page span blues, jazz, swing, and Latin
  projects (a partial selection; Russ has played on more recordings over the
  years that aren't surfaced here). See the
  <a [routerLink]="'/about/discography'">discography</a>
  for streamable tracks, and the
  <a [routerLink]="'/about/credits'">credits</a>
  page for the broader list of national and local artists he's shared the
  bandstand with.
</p>

<h2>Live Performances</h2>
<p>A small selection from a much larger catalog of live performance footage.</p>

<div class="performance-video-grid groove-grid" style="--_grid-min: 360px">
  <figure class="performance-video">
    <app-youtube-section resource="video:iNouBEOeOhU" />
    <figcaption class="performance-caption">
      Green Island Lounge — &quot;Days Of Wine And Roses&quot; (October 2025)
    </figcaption>
  </figure>

  <figure class="performance-video">
    <app-youtube-section resource="video:u5DPEdXvI5I" />
    <figcaption class="performance-caption">
      JoJo in Washington, DC — jazz set (July 2025)
    </figcaption>
  </figure>

  <figure class="performance-video">
    <app-youtube-section resource="video:ntedE6BPjaM" />
    <figcaption class="performance-caption">
      Bobby Thompson Group — &quot;Key To The Highway&quot; (June 2025)
    </figcaption>
  </figure>

  <figure class="performance-video">
    <app-youtube-section resource="video:iYnR9qSGY0I" />
    <figcaption class="performance-caption">
      Swamp Dog — &quot;Get Down&quot; (July 2025)
    </figcaption>
  </figure>
</div>

<p>
  More of both on the channel: the
  <a
    href="https://www.youtube.com/playlist?list=PLnRW_LWLpwnfyhYTRqo5peLcVujRW9ULG"
    target="_blank"
    rel="noopener"
    >Jazz Performances playlist</a
  >
  and the
  <a
    href="https://www.youtube.com/playlist?list=PLnRW_LWLpwnelyiq1cMVeaTtKqqrbVsD4"
    target="_blank"
    rel="noopener"
    >Blues playlist</a
  >.
</p>

<h2>Looking To Connect With</h2>
<p>
  Established bandleaders, recording session work, clinics, and projects with
  serious players across South Florida. If you've heard the videos and the
  discography and want to talk about a specific project, reach out directly:
</p>
<app-contact-details />

<section aria-labelledby="performance-gallery-heading">
  <h2 id="performance-gallery-heading">Performance Pictures</h2>
  <app-image-gallery [images]="galleryImages" />
</section>
